import React, { useRef, useState, useEffect } from "react";
import videojs from "video.js";
import "./Video.css";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import Stories, { WithSeeMore } from "react-insta-stories";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
var ImageData = "";
var SVGIcon = "";

ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

export default function Video({
  channel,
  song,
  url,
  likes,
  comment,
  shares,
  Videodata,
}) {
  const [isVideoPlaying, setisVideoPlaying] = useState(false);
  const [player, setPlayer] = useState(false);
  const [scrollstatus, setscrollstatus] = useState(false);
  
  var vidRef = useRef();
  const onVideoClick = () => {
    if (isVideoPlaying) {
      setisVideoPlaying(false);
    } else {
      vidRef.current.play();
      setisVideoPlaying(true);
    }
  };
  function isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  useEffect(
    () => {
      let options = {
        rootMargin: "0px",
        threshold: [0.25, 0.75],
      };

      let handlePlay = (entries, observer) => {
        console.log("hhhh")
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            vidRef.current.currentTime = 0;
            //vidRef.current.seek();
            
            if(vidRef){
              vidRef.current.play();
            }
          } else {
            vidRef.currentTime = 0;
            
            if(vidRef){
              vidRef.current.play();
            }
          }
        });
      };

      let observer = new IntersectionObserver(handlePlay, options);

      observer.observe(vidRef.current);

      const videoJsOptions = {
        autoplay: false,
        autoPlay: false,
        kind: "captions",
        preload: "auto",
        aspectRatio: "15:15",
        height: "auto",
        width: "100%",
        controls: false,
        sources: [
          {
            src: Videodata.preview_url_vertical.preview_url1_vertical,
            type: "application/x-mpegURL",
            withCredentials: false,
          },
        ],
      };
      if (player) {
        player.hlsQualitySelector({ displayCurrentQuality: true });
      }

      const p = videojs(vidRef.current, videoJsOptions);
      setPlayer(p);
      return () => {
        if (player) player.dispose();
      };
    },
    [player],
    [scrollstatus]
  );

  return (
    <SwiperSlide >
    <main>
      <section className="mb-0">
        
        <div className="video-cards">
          <video onClick={onVideoClick} className="video-player" ref={vidRef} />
        </div>
        <div className="temp48">
          <div className="temp48-area">
            <div className="temp48-img">
              <img src={SVGIcon["like-red.svg"]} />
            </div>
            <div className="temp48-text">1.5k</div>
          </div>
          <div className="temp48-area">
            <div className="temp48-img">
              <img src={SVGIcon["share.svg"]} />
            </div>
            <div className="temp48-text">Share</div>
          </div>
          <div className="temp48-area">
            <div className="temp48-img">
              <img src={SVGIcon["watchlist.svg"]} />
            </div>
            <div className="temp48-text">Watchlist</div>
          </div>
        </div>
        <div className="temp49">
          <div className="temp49-img">
            {" "}
            <img src={Videodata.preview_image_1.original} alt="Docubytes" />
          </div>
          <div className="temp49-text">
            <h6>{Videodata.title}</h6>
            <p>{Videodata.genres}</p>
          </div>
        </div>
      </section>
    </main>
   </SwiperSlide > 
  );
}

const image = {
  display: "block",
  maxWidth: "100%",
  borderRadius: 4,
};

const code = {
  background: "#eee",
  padding: "5px 10px",
  borderRadius: "4px",
  color: "#333",
};

const contentStyle = {
  background: "#333",
  width: "100%",
  padding: 20,
  color: "white",
  height: "100%",
};

const customSeeMore = {
  textAlign: "center",
  fontSize: 14,
  bottom: 20,
  position: "relative",
};
